import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import { getPersistConfig } from "redux-deep-persist";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import reducers from "./reducers";
import rootSaga from "./sagas";

const sagaMiddleware = createSagaMiddleware();

const persistConfig = getPersistConfig({
  key: "root",
  storage,
  stateReconciler: autoMergeLevel2,
  blacklist: ["form", "loaderReducer,FPXReducer.errorPaymentPay", "FPXReducer.rspStatus"],
  // whitelist: ['auth'],
  rootReducer: reducers
});

const globalReducer = (state, action) => {
  if (action.type === "USER_SIGNED_OUT") {
    state = undefined;
  }

  return reducers(state, action);
};

const persistedReducer = persistReducer(persistConfig, globalReducer);

export default function configureStore(initialState = {}) {
  const middlewares = [sagaMiddleware];

  const enhancers = [applyMiddleware(...middlewares)];

  const composeEnhancers =
    process.env.NODE_ENV !== "production" &&
    typeof window === "object" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          shouldHotReload: false
        })
      : compose;

  const store = createStore(
    persistedReducer,
    initialState,
    composeEnhancers(...enhancers)
  );

  const persistor = persistStore(store, {}, () => {
    const state = store.getState();
  });

  store.runSaga = sagaMiddleware.run(rootSaga);

  return { persistor, store };
}
